export const SET_FORGOT_PASSWORD_STATUS = 'login/SET_FORGOT_PASSWORD_STATUS';
export const START_FORGOT_PASSWORD = 'login/START_FORGOT_PASSWORD';
